import { ExpandableTextPops } from './types';
import View from './View';

export { default as View, getExpandableTextStyles } from './View';

export const useViewModel = (props: ExpandableTextPops) => props;
export default View;
